import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import useNavigation from "../../hooks/useNavigation";
import useCheckBinding from "../../hooks/useCheckBinding";
import WalletRouterBtn from "./WalletRouterBtn";
import { WalletInfoProps } from "./types";
import buyImg from "../../assets/images/wallet/buy.png";
import sellImg from "../../assets/images/wallet/sell.png";
import swapImg from "../../assets/images/wallet/swap.png";
import orderImg from "../../assets/images/wallet/order.png";
import realnameImg from "../../assets/images/wallet/realname2.png";
import receiverpayImg from "../../assets/images/wallet/receiverpay.png";
import paypasswordImg from "../../assets/images/wallet/paypassword.png";
import appealImg from "../../assets/images/wallet/appeal.png";
import myOrderImg from "../../assets/images/wallet/myorder.png";
import creditratingImg from "../../assets/images/wallet/creditrating.png";
import buytutorialImg from "../../assets/images/wallet/buytutorial.png";
import selltutorialImg from "../../assets/images/wallet/selltutorial.png";
import userinstructionImg from "../../assets/images/wallet/userinstruction.png";
import shareImg from "../../assets/images/wallet/share.png";
import settingImg from "../../assets/images/wallet/setting.png";

const Box = styled.div`
  border-radius: 12px;
  padding: 5px 15px;
  background: rgb(247, 248, 255);
`;
const Card = styled.div`
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 15px;
  background: #fff;
`;
const Title = styled.div`
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 8px;
`;
const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const WalletRouterBlock: React.FC<WalletInfoProps> = ({ pay_pwd }) => {
  const navigation = useNavigation();
  const { handleCheckBindingWpPassword, handleCheckBindingPhone } =
    useCheckBinding();
  return (
    <Box>
      <Card>
        <Title>交易系统</Title>
        <Row>
          <WalletRouterBtn
            onPress={() => navigation.navigate("BuyCoinList")}
            imgSrc={buyImg}
            title="购买"
          />
          <WalletRouterBtn
            onPress={() => navigation.navigate("MyOrderList")}
            imgSrc={sellImg}
            title="出售"
          />
          <WalletRouterBtn
            onPress={() =>
              handleCheckBindingWpPassword().then(() =>
                navigation.navigate("Exchange")
              )
            }
            imgSrc={swapImg}
            title="充值"
          />
          <WalletRouterBtn
            onPress={() => navigation.navigate("TakeOrders")}
            imgSrc={orderImg}
            title="订单"
          />
        </Row>
      </Card>
      <Card>
        <Title>常用功能</Title>
        <Row>
          <WalletRouterBtn
            onPress={() => navigation.navigate("Verified")}
            imgSrc={realnameImg}
            title="实名认证"
          />
          <WalletRouterBtn
            onPress={() => navigation.navigate("PayAccountManage")}
            imgSrc={receiverpayImg}
            title="收付款"
          />
          <WalletRouterBtn
            onPress={() =>
              handleCheckBindingPhone().then(() =>
                navigation.navigate("SettingPayNumber")
              )
            }
            imgSrc={paypasswordImg}
            title="支付密码"
          />
          <WalletRouterBtn
            onPress={() => navigation.navigate("MyComplaint")}
            imgSrc={appealImg}
            title="我的申诉"
          />
        </Row>
        <Row>
          <WalletRouterBtn
            onPress={() => navigation.navigate("MyBill")}
            imgSrc={myOrderImg}
            title="我的账单"
          />
          <WalletRouterBtn
            onPress={() => navigation.navigate("CreditRating")}
            imgSrc={creditratingImg}
            title="信用等级"
          />
          <WalletRouterBtn
            onPress={() => navigation.navigate("TutorialMap", { kind: "buy" })}
            imgSrc={buytutorialImg}
            title="买入教程"
          />
          <WalletRouterBtn
            onPress={() => navigation.navigate("TutorialMap", { kind: "sell" })}
            imgSrc={selltutorialImg}
            title="卖出教程"
          />
        </Row>
        <Row>
          <WalletRouterBtn
            onPress={() => navigation.navigate("UserNotice")}
            imgSrc={userinstructionImg}
            title="用户须知"
          />
          <WalletRouterBtn
            onPress={() => navigation.navigate("Share")}
            imgSrc={shareImg}
            title="分享"
          />
          <WalletRouterBtn
            onPress={() => navigation.navigate("SettingDomain")}
            imgSrc={settingImg}
            title="设置"
          />
          <div style={{ flex: 1, minWidth: "25%" }} />
        </Row>
      </Card>
    </Box>
  );
};

export default observer(WalletRouterBlock);
